import Table from './src/table';
import TableColumn from './src/table-column';

module.exports = {
    Table,TableColumn
}


// WEBPACK FOOTER //
// ./src/components/table/index.js